@if (!isNextPage) {
  <div class="content-container">
    <img src="/assets/img/icons/svgs/update-successful.svg" alt="update-successful" class="logo" />
    <h5 class="content-title">Profile successfully updated</h5>
    <p class="content-subtitle">What would you like to do next?</p>
    <div class="button-group">
      <button class="custom-btn custom-primary button-text" (click)="nextpage()">
        Start Your Fundraising Application
      </button>
      <button class="custom-btn custom-secondary button-text" (click)="explore()">
        Explore pitchIN Crowdfunding
      </button>
      <a class="cancel-text button-text" (click)="stay()">I'll do this later</a>
    </div>
  </div>
}
@if (isNextPage) {
  <div class="content-container-next">
    <h5 class="content-title">Select Crowdfunding Type</h5>
    <p class="content-subtitle">
      Choose the type of crowdfunding application you want to start with
    </p>
    <div class="button-group">
      <button class="custom-btn-nxt custom-primary-nxt" (click)="ecf()">
        <span class="button-title-ecf">ECF</span>
        <span class="button-text">Equity Crowdfunding</span>
      </button>
      <button class="custom-btn-nxt custom-secondary-nxt" (click)="tcf()">
        <span class="button-title-tcf">TCF</span>
        <span class="button-text"> Token Crowdfunding</span>
      </button>
      <a class="cancel-text button-text" (click)="backpage()">Back</a>
    </div>
  </div>
}
